import { AsyncState, unloadedAsyncState } from 'widgets-for-react'
import { ParsedMenuItem } from '../../legacy/public_site/components/drupal/types_and_parser/extra_types.mod'

export type SiteheaderState = { mode: 'closed' | 'open'; navLinks: AsyncState<Array<ParsedMenuItem>> }

export const initialSiteheaderState: SiteheaderState = { mode: 'closed', navLinks: unloadedAsyncState() }
